import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

import css from './SearchResultsPanel.css'
import type { SearchResultsPanelProps as Props } from './types'

const lineHeight = { lineHeight: '2.4rem' }

export const SearchResultsPanel: FC<Props> = ({ currentMode, foundNumber }) => {
  const isCrmsMode = currentMode === 'crms'
  return (
    <div className={css.container}>
      <Text view="ghost" size="s" weight="medium" style={lineHeight} className={css.searchText}>
        Результаты поиска: {isCrmsMode ? '' : foundNumber}
      </Text>
      {!!isCrmsMode && (
        <Text size="s" view="secondary" weight="medium" style={lineHeight} className={css.info}>
          *Из БД ЦРМС мы грузим пока только 3D кубы. Скоро мы добавим и другой функционал.
        </Text>
      )}
      {/* TODO Раскомментировать, когда будет готов функционал
      <Button
        size="s"
        view="ghost"
        label="В обработку все"
        iconLeft={IconDownload}
        onClick={() => undefined}
      /> */}
    </div>
  )
}
